import React from 'react';
import { useSelector } from 'react-redux';

import FilterBar from '../../components/filters/FilterBar';
import LoadingSpinner from '../../components/elements/LoadingSpinner';
import TripsContainer from '../../components/elements/TripsContainer';
import { getToursLoading } from '../../redux/reducers/tours';

import '../../styles/scss/structure/tours-container.scss';

const ToursContainer = () => {
  const loading = useSelector(getToursLoading);

  return (
    <div className="u-flex tours-container">
      {loading && <LoadingSpinner />}
      {!loading && (
        <>
          <FilterBar />
          <TripsContainer />
        </>
      )}
    </div>
  );
};

export default ToursContainer;
